// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-avatar {
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  font-size: 12px;
}

.date-input-wrapper {
  display: flex;
  align-items: baseline;
  width: 100%;
}
.date-input-wrapper ion-icon {
  margin-top: 0;
  margin-bottom: 21px;
  margin-right: 16px;
}

.datetime-modal {
  background: rgba(0, 0, 0, 0.2784313725);
  padding-bottom: 50px;
}

ion-modal {
  background: rgba(15, 14, 14, 0.3803921569);
}
ion-datetime {
  --background: white;
  color: #a8a2a2 !important;
}

.pd-time {
  padding-left: 20px;
}

.cont-item {
  padding: 0px 10px;
}
.cont-item ion-item {
  margin-bottom: 16px;
  --box-shadow: 0px 0px 3px 1px rgba(12, 35, 64, 0.20) inset;
  --border-radius: 8px;
  border: 2px solid #f3f4f6;
  border-radius: 7px;
  --padding-start: 14px;
}
.cont-item ion-item ion-label {
  color: #586677;
  font-weight: 500;
  font-size: 14px;
}
.cont-item ion-item ion-input {
  bottom: -8px;
}

.textarea-select {
  top: 3px;
}

.input-assistance {
  top: 6px;
}
.input-assistance ion-icon {
  position: relative;
  bottom: 5px;
}

.chips-panel {
  padding-top: 14px;
}

.container-attendees {
  cursor: pointer;
  background: white;
  margin-bottom: 10px;
  border-radius: 16px;
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.2) inset;
  --padding-start: 16px;
  --padding-end: 16px;
}
.container-attendees .item-title {
  margin-bottom: 0px;
}
.container-attendees .clean-item-border {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.container-attendees .chips-panel {
  border: none;
  box-shadow: none;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.container-attendees .chips-panel .container-chips {
  margin-top: 12px;
}
.container-attendees .chips-panel .container-chips ion-chip {
  height: 36px;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/events-core/lib/components/event-form/event-form.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,WAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;;AAGA;EACE,uCAAA;EACA,oBAAA;AAAF;;AAWA;EACE,0CAAA;AARF;AAkCA;EACE,mBAAA;EACA,yBAAA;AAhCF;;AAmCA;EACE,kBAAA;AAhCF;;AAoCA;EACE,iBAAA;AAjCF;AAmCE;EACE,mBAAA;EACA,0DAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AAjCJ;AAmCI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAjCN;AAoCI;EACE,YAAA;AAlCN;;AAuCA;EACE,QAAA;AApCF;;AAuCA;EACE,QAAA;AApCF;AAsCE;EACE,kBAAA;EACA,WAAA;AApCJ;;AAwCA;EACE,iBAAA;AArCF;;AAwCA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oDAAA;EACA,qBAAA;EACA,mBAAA;AArCF;AAuCE;EACE,kBAAA;AArCJ;AAwCE;EACE,8BAAA;EACA,+BAAA;AAtCJ;AAyCE;EACE,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;AAvCJ;AAyCI;EACE,gBAAA;AAvCN;AAyCM;EACE,YAAA;AAvCR","sourcesContent":["ion-avatar {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  font-size: 12px;\n}\n\n.date-input-wrapper {\n  display: flex;\n  align-items: baseline;\n  width: 100%;\n  ion-icon {\n    margin-top: 0;\n    margin-bottom: 21px;\n    margin-right: 16px;\n  }\n}\n\n\n.datetime-modal{\n  background: #00000047;\n  padding-bottom: 50px;\n}\n\n// .hacking-datetime {\n//   display: grid;\n//   grid-template-columns: 1fr 2fr;\n//   position: absolute;\n//   bottom: 0;\n//   width: 100%;\n// }\n\nion-modal {\n  background: #0f0e0e61;\n\n  &.bottom-end {\n    //align-items: flex-end;\n    //--height: auto;\n    // .ion-page {\n    //   position: relative;\n    //   display: block;\n    //   contain: content;\n    // }\n  }\n}\n\n// ion-modal {\n//   &.bottom-end {\n//     align-items: flex-end;\n//     --height: auto;\n\n//     .ion-page {\n//       position: relative;\n//       display: block;\n//       contain: content;\n//     }\n//   }\n// }\n\nion-datetime {\n  --background: white;\n  color: #a8a2a2 !important;\n}\n\n.pd-time{\n  padding-left: 20px;\n}\n\n//New form\n.cont-item{\n  padding: 0px 10px;\n\n  ion-item{\n    margin-bottom: 16px;\n    --box-shadow: 0px 0px 3px 1px rgba(12, 35, 64, 0.20) inset;\n    --border-radius: 8px;\n    border: 2px solid #f3f4f6;\n    border-radius: 7px;\n    --padding-start: 14px;\n\n    ion-label{\n      color: #586677;\n      font-weight: 500;\n      font-size: 14px;\n    }\n\n    ion-input{\n      bottom: -8px;\n    }\n  }\n}\n\n.textarea-select{\n  top: 3px;\n}\n\n.input-assistance{\n  top: 6px;\n\n  ion-icon{\n    position: relative;\n    bottom: 5px;\n  }\n}\n\n.chips-panel{\n  padding-top: 14px;\n}\n\n.container-attendees{\n  cursor: pointer;\n  background: white;\n  margin-bottom: 10px;\n  border-radius: 16px;\n  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.2) inset;\n  --padding-start: 16px;\n  --padding-end: 16px;\n\n  .item-title{\n    margin-bottom: 0px;\n  }\n\n  .clean-item-border{\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n\n  .chips-panel{\n    border: none;\n    box-shadow: none;\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n\n    .container-chips{\n      margin-top: 12px;\n\n      ion-chip{\n        height: 36px;\n      }\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
